import { Text, TextProps } from "../Typography"
import { styled, StyleProps, callCSSFn, CSS } from "../styles"

interface ITitleProps {
  variant?: TitleVariant
  tag?: string
}

type TitleVariant = "headline1" | "headline2" | "headline3"
export type TitleProps = ITitleProps & StyleProps & Omit<TextProps, `use` | "ref" | `as`>

export const TitleComponent = ({ variant, tag, ...props }: TitleProps) => (
  <Text use={variant} tag={tag || variant === `headline1` ? `h1` : `h2`} {...props} />
)

TitleComponent.defaultProps = {
  variant: `headline1`,
  tag: `h1`,
}

export const makeStyledTitle = <T extends unknown>(component: (props: T) => JSX.Element) =>
  styled(component)(
    (props: TitleProps & T): CSS => ({
      lineHeight: 1,
      textTransform: `uppercase`,
      ...callCSSFn(props),
    })
  )

export const Title = makeStyledTitle(TitleComponent)
